import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { startsWith } from 'lodash';
import injectSheet from 'react-jss';

import Input from '@eg/elements/Input';
import ArrowDownIcon from '@eg/elements/Icons/ArrowDownIcon';
import Autocomplete from '@eg/elements/Autocomplete';

import { getTranslationArray } from '../../helpers/polyglot';
import FormMessage from '../FormMessage';

import styles from './styles.jss';

class IdentityAutocomplete extends PureComponent {
  state = {
    identitiesSuggestions: [],
    initialFlatIdentietiesList: [],
    identityName: '',
  }

  componentDidMount() {
    const {
      name,
      value,
      onChange,
      placeholder,
    } = this.props;

    const identityList = getTranslationArray('dropdowns.identities');
    const flatIdentityList = this.flatIdentityList(identityList);
    const identityName = value || placeholder;
    onChange(name)(identityName);

    this.setState({
      initialFlatIdentietiesList: flatIdentityList,
      identitiesSuggestions: flatIdentityList,
      identityName,
    });
  }

  searchSuggestions = value => {
    const { initialFlatIdentietiesList } = this.state;
    const { name, onChange } = this.props;

    const identitiesSuggestions = initialFlatIdentietiesList.filter(
      this.filterSuggestions,
      value,
    );

    this.setState({
      identitiesSuggestions,
      identityName: value,
    });

    onChange(name)(value);
  }

  getInputWithArrow = (props) => (
    <Input
      {...props}
      ref={el => el && props.ref(el.input)}
      adornmentRight={ArrowDownIcon}
    />
  );

  flatIdentityList = identityList => identityList.reduce(
    (aggr, val) => {
      aggr.push(val.name);
      return aggr;
    },
    [],
  );

  // don't refactor this one to fat arrow fn - it gets the "wrong" this
  filterSuggestions(haystack) {
    return startsWith(haystack.toLowerCase(), this.toLowerCase());
  }

  render() {
    const {
      identityName,
      identitiesSuggestions,
    } = this.state;

    const {
      name,
      description,
      classes,
      error,
    } = this.props;

    return (
      <div className={classes.wrapperForAutocompleteSuggestions}>
        <Autocomplete
          value={identityName}
          name={name}
          onChange={this.searchSuggestions}
          suggestions={identitiesSuggestions}
          renderInput={this.getInputWithArrow}
        />
        <FormMessage
          error={error}
          description={description}
        />
      </div>
    );
  }
}

IdentityAutocomplete.propTypes = {
  name: PropTypes.string,
  error: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  onChange: PropTypes.func,
  value: PropTypes.string,
  description: PropTypes.string,
  placeholder: PropTypes.string,
};

IdentityAutocomplete.defaultProps = {
  name: '',
  classes: {},
  error: '',
  onChange: () => { },
  value: '',
  description: '',
  placeholder: '',
};

export { IdentityAutocomplete as IdentityAutocompletePlain };
export default injectSheet(styles)(IdentityAutocomplete);
